//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { rankLevelBatchApi, rankLevelEditApi, rankLevelSaveApi } from '@/api/setting';
export default {
  name: 'RankDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var checkLevelMin = function checkLevelMin(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入最低职等'));
      }
      setTimeout(function () {
        if (_this.formData.levelMax && value > _this.formData.levelMax) {
          callback(new Error('最低职等不能大于最高职等'));
        } else {
          callback();
        }
      }, 150);
    };
    return {
      dialogVisible: false,
      labelWidth: '90px',
      formData: {
        levelMin: undefined,
        levelMax: undefined,
        salaryMin: undefined,
        salaryMax: undefined,
        rank: undefined
      },
      rules: {
        levelMin: [{
          required: true,
          validator: checkLevelMin,
          trigger: 'blur'
        }],
        levelMax: [{
          required: true,
          message: '请输入最高职等',
          trigger: 'blur'
        }],
        salaryMin: [{
          required: true,
          message: '请输入最低薪资',
          trigger: 'blur'
        }],
        salaryMax: [{
          required: true,
          message: '请输入最高薪资',
          trigger: 'blur'
        }],
        rank: [{
          required: true,
          message: '请输入职等跨度',
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        if (nVal.type === 2) {
          this.labelWidth = '110px';
        } else {
          this.labelWidth = '90px';
        }
        if (nVal.edit) {
          if (nVal.type === 1) {
            this.formData.levelMin = nVal.data.min_level;
            this.formData.levelMax = nVal.data.max_level;
            var arr = nVal.data.salary.split('-');
            this.formData.salaryMin = Number(arr[0]);
            this.formData.salaryMax = Number(arr[1]);
          }
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    reset: function reset() {
      this.formData.levelMin = undefined;
      this.formData.levelMax = undefined;
      this.formData.salaryMin = undefined;
      this.formData.salaryMax = undefined;
      this.formData.rank = undefined;
    },
    handleClose: function handleClose() {
      this.$refs.form.clearValidate();
      this.dialogVisible = false;
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var data = {};
          if (_this2.config.type === 1) {
            data.salary = _this2.formData.salaryMin + '-' + _this2.formData.salaryMax;
            data.min_level = _this2.formData.levelMin;
            data.max_level = _this2.formData.levelMax;
            if (_this2.config.edit === false) {
              _this2.rankLevelSave(data);
            } else {
              _this2.rankLevelEdit(_this2.config.data.id, data);
            }
          } else if (_this2.config.type === 2) {
            _this2.rankLevelBatch(_this2.formData.rank);
          }
        }
      });
    },
    // 职位等级添加
    rankLevelSave: function rankLevelSave(data) {
      var _this3 = this;
      this.loading = true;
      rankLevelSaveApi(data).then(function (res) {
        _this3.handleClose();
        _this3.loading = false;
        _this3.$emit('isOk');
        _this3.reset();
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    // 职位等级编辑
    rankLevelEdit: function rankLevelEdit(id, data) {
      var _this4 = this;
      this.loading = true;
      rankLevelEditApi(id, data).then(function (res) {
        _this4.handleClose();
        _this4.loading = false;
        _this4.$emit('isOk');
        _this4.reset();
      }).catch(function (error) {
        _this4.loading = false;
      });
    },
    // 批量修改职位区间
    rankLevelBatch: function rankLevelBatch(id) {
      var _this5 = this;
      this.loading = true;
      rankLevelBatchApi(id).then(function (res) {
        _this5.handleClose();
        _this5.loading = false;
        _this5.$emit('isOk');
        _this5.reset();
      }).catch(function (error) {
        _this5.loading = false;
      });
    }
  }
};